import get from "get-value";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import { clearAlerts } from "../../../actions/alertsActions";
import {
    lockAseInternalTicket,
    resetRedirectAfterAseInternalLockTicket,
} from "../../../actions/ase/actionAseInternalLockTicket";
import {
    fetchAseInternalTicket,
    resetAseInternalTicket,
    updateAseInternalTicket,
} from "../../../actions/ase/actionAseInternalTicket";
import { editRights } from "../../../constants/aseInternalTicketRights";
import {
    FORM_BUTTON_EDIT,
    FORM_BUTTON_REOPEN,
    FORM_BUTTON_TAKE_BACK,
} from "../../../constants/formConstants";
import formMessages from "../../../intl/afterSales/formMessages";
import formTypeMessages from "../../../intl/common/formTypeMessages";
import { ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET } from "../../../routes/paths";
import { formatInternalTicketNumber } from "../../../utils/utils";
import Loader from "../../Loader";
import PageHeader from "../../common/PageHeader";
import ValidFormattedMessage from "../../common/ValidFormattedMessage";
import checkRoles from "../../common/roleChecker/RoleChecker";
import {
    initLoadedAseInternalTicket,
    transformUpdateAseInternalTicketForSave,
} from "../Utils";
import InternalTechnicalBulletinTicketMasterForm from "./forms/InternalTechnicalBulletinTicketMasterForm";

class ViewAseInternalTechnicalBulletinTicketPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectToEdit: false,
            ticketSubmitted: false,
            storedTicketData: {},
            redirectToEditImmediately: false,
            checkStatusSkipAfterUpdateRedirect: false,
        };
    }

    componentDidMount() {
        if (!this.props.location.redirectedAfterUpdate) {
            this.props.fetchAseInternalTicket(
                this.props.match.params.ticketUuid,
            );
        }
    }

    componentWillUnmount() {
        this.props.resetAseInternalTicket();
        this.props.resetRedirectAfterAseInternalLockTicket();
    }

    handleSubmit = (values) => {
        const { submitBy } = values;
        const { ticketData } = this.props;

        switch (submitBy) {
            case FORM_BUTTON_REOPEN:
                this.props.lockAseInternalTicket(
                    this.props.match.params.ticketUuid,
                );
                this.setState({
                    redirectToEdit: true,
                    ticketSubmitted: true,
                    storedTicketData:
                        transformUpdateAseInternalTicketForSave(values),
                });
                break;
            case FORM_BUTTON_TAKE_BACK:
                this.props.lockAseInternalTicket(
                    this.props.match.params.ticketUuid,
                );
                this.setState({
                    checkStatusSkipAfterUpdateRedirect: true,
                    redirectToEdit: true,
                    ticketSubmitted: true,
                    storedTicketData:
                        transformUpdateAseInternalTicketForSave(values),
                });
                break;
            case FORM_BUTTON_EDIT:
                this.setState({
                    redirectToEditImmediately: true,
                    redirectToTicket: ticketData.ticket.uuid,
                });
                this.props.resetAseInternalTicket();
                break;
            default:
                break;
        }
    };

    render() {
        const { ticketData } = this.props;

        let formType = false;
        if (get(ticketData, "ticket.formType", { default: false })) {
            formType = ticketData.ticket.formType;
        }

        if (
            !this.props.lockTicket.isTicketLocking &&
            !this.props.lockTicket.redirect &&
            this.state.ticketSubmitted &&
            this.state.redirectToEdit
        ) {
            this.props.updateAseInternalTicket(this.state.storedTicketData);
            return (
                <Redirect
                    to={{
                        pathname: `${ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET}/edit/${ticketData.ticket.uuid}`,
                        redirectedAfterUpdate: true,
                        checkStatusSkipAfterUpdateRedirect:
                            !!this.state.checkStatusSkipAfterUpdateRedirect,
                    }}
                />
            );
        } else if (this.state.redirectToEditImmediately) {
            return (
                <Redirect
                    to={{
                        pathname: `${ASE_INTERNAL_TECHNICAL_BULLETIN_TICKET}/edit/${this.state.redirectToTicket}`,
                    }}
                />
            );
        } else if (
            !this.props.lockTicket.isTicketLocking &&
            !this.props.lockTicket.redirect &&
            this.state.ticketSubmitted
        ) {
            this.props.updateAseInternalTicket(this.state.storedTicketData);
            this.setState({ ticketSubmitted: false, storedTicketData: {} });
        }

        const initializationValue = initLoadedAseInternalTicket(ticketData);

        if (
            ticketData.isTicketLoading ||
            ticketData.isTicketCreating ||
            !formType
        ) {
            return <Loader />;
        }

        return (
            <div id="ticketPrint" className="container-fluid">
                <PageHeader
                    title={
                        <>
                            <FormattedMessage {...formMessages.TICKET} />{" "}
                            {formatInternalTicketNumber(
                                ticketData.ticket.pfxNumber,
                                ticketData.ticket.sfxNumber,
                            )}
                            {"-"}
                            <ValidFormattedMessage
                                message={formType}
                                intlMessages={formTypeMessages}
                            />
                        </>
                    }
                />
                <div>
                    <InternalTechnicalBulletinTicketMasterForm
                        form={formType}
                        initialValues={initializationValue}
                        userRights={
                            editRights["AS_SG_EDITOR"][ticketData.ticket.status]
                        }
                        enableReinitialize={true}
                        handleSubmit={this.handleSubmit}
                        reqFields={[]}
                        readOnly
                        showDocumentationUpdate
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: state.profile.userDetail.roles,
    ticketData: state.aseInternalTicket,
    lockTicket: state.aseLockInternalTicketCheck,
});

ViewAseInternalTechnicalBulletinTicketPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
    location: PropTypes.object,
    ticketData: PropTypes.object.isRequired,
    fetchAseInternalTicket: PropTypes.func.isRequired,
    resetAseInternalTicket: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    intl: PropTypes.any.isRequired,
};

export default checkRoles(
    withRouter(
        connect(mapStateToProps, {
            fetchAseInternalTicket,
            resetAseInternalTicket,
            lockAseInternalTicket,
            updateAseInternalTicket,
            resetRedirectAfterAseInternalLockTicket,
            clearAlerts,
        })(injectIntl(ViewAseInternalTechnicalBulletinTicketPage)),
    ),
    ["AS_SG_EDITOR"],
);

